import React from 'react';

export default function NoMatch () {
  return (
    <div className="d-flex justify-content-center align-items-center p-5">
      <h4>Not Found</h4>
    </div>
  );
};
